<template>
			<v-layout column justify-start style="">
			<PhotoUpload />	
				<v-card flat class="title">
					<v-layout class="subheading pt-4 mb-4 mx-3 ">
					<v-flex class="pt-2">ROOM DETAILS</v-flex>
					<v-flex xs2 class="text-xs-right">
						<v-icon class="mr-2" @click="showAmenities">grading</v-icon>
						<v-icon @click="addPhoto">add_a_photo</v-icon>
					</v-flex>
					</v-layout>
					<v-layout class="py-3 px-3" style="background-color: RebeccaPurple; color: white;" >
						<v-flex >{{selectedRoom.number}}</v-flex>
						<v-flex class="text-truncate" style="margin-top: -1px;">{{selectedBuilding.name}}</v-flex>	
						<!-- <v-flex xs2 class="text-xs-right"><v-icon dark @click="addPhoto">add_a_photo</v-icon></v-flex> -->
					</v-layout>
				</v-card>
				<v-card flat v-if="roomPhotos" height="300" class="">

	    		<v-pannellum autoRotate v-if="room360PhotoURL" :src="room360PhotoURL" :hfov="100" showZoom showFullscreen>
	    		</v-pannellum> 
	    		<v-carousel v-if="!room360PhotoURL" height="300" hide-delimiters cycle interval="4000"
	    			:hide-controls="this.selectedRoom && this.selectedRoom.roomImages.length > 1 ? false : true">
				    <v-carousel-item
				      v-for="(photo,i) in roomPhotos"
				      @click="setShowPhotoViewer(true)"
				      :key="i"
				      :src="photo.url">
				    	<span class="headline" v-if="!photo.reviewed" style="position: absolute; left: 10px; top: 3px;" >
							Pending
						</span>
					</v-carousel-item>
					
				 </v-carousel>  
				 
          		</v-card>

          		<v-btn v-if="this.selectedRoom && this.selectedRoom.roomImages.length > 1"
          			class="buttonhigher2" @click="setShowPhotoViewer(true)" >          			
	        		GALLERY
	        		</v-btn>
          		<v-card flat style="background-color: lightgrey; 
          				padding-left: 23px; padding-right: 10px; padding-top: 10px; padding-bottom:20px;">
          		<v-layout class="mt-3" style="z-index: 100;"  column>
	    		<v-layout row 
		    		v-for="(item, index) in items"
		    		:key="index" 
		    		class="mb-1 "	    		
		    		style="align-items: flex-start;"
		    		align-start>
		        		<v-flex color="grey darken-1 " xs4>{{ item.label }}</v-flex>
		        		<v-flex color="grey darken-1 " xs8>{{ item.val }}</v-flex>
		        </v-layout>		
       
				</v-layout>
				</v-card>
			</v-layout>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import PhotoUpload from './forms/PhotoUpload'
import { NETID_COOKIE } from '@/store/modules/user'
import jscookie from 'js-cookie'

	export default {
		data () {
			return {
			}
		},

		components: { PhotoUpload },

		computed: {
			...mapState({ 	selectedRoom: state => state.space.selectedRoom, 
							selectedBuilding: state => state.space.selectedBuilding,
							isSuperUser: state => state.user.isSuperUser,
			}),

			items: function () {
			  	if (this.$store.state.space.selectedRoom) {
			  	return 	[
				  		{ label: 'Area', val: this.$store.state.space.selectedRoom.area + " sf"},
				  		{ label: 'College', val: this.$store.state.space.selectedRoom.collegeName + " (" + this.$store.state.space.selectedRoom.collegeID + ")" },
				  		{ label: 'Dept', val: this.$store.state.space.selectedRoom.deptName + " (" + this.$store.state.space.selectedRoom.deptID + ")" },
				  		{ label: 'Category', val: this.$store.state.space.selectedRoom.categoryName + " (" + this.$store.state.space.selectedRoom.category + ")" },
				  		{ label: 'Type', val: this.$store.state.space.selectedRoom.typeName + " (" + this.$store.state.space.selectedRoom.type + ")" },
				  		{ label: 'Use', val: this.$store.state.space.selectedRoom.useName + " (" + this.$store.state.space.selectedRoom.use + ")" },
				  		{ label: 'Capacity', val: this.$store.state.space.selectedRoom.capacity },
				  		{ label: 'Class', val: this.$store.state.space.selectedRoom.classification},
			  			]
			  	}
			},

			roomPhotos : function () {
				let returnVal = []
				this.selectedRoom && this.selectedRoom.roomImages && this.selectedRoom.roomImages.length > 0 && 
				this.selectedRoom.roomImages.forEach((photo) => {
					if (photo.reviewed || this.isOwner(photo)) { returnVal.push(photo) }
				})
				return returnVal.length > 0 ? returnVal : null
			},

			room360PhotoURL : function(){
				let returnVal = null
				if (this.selectedRoom && this.selectedRoom.roomImages && this.selectedRoom.roomImages.length > 0 ) {
					this.selectedRoom.roomImages.forEach((photo) => {
						if (photo.url.includes("360Pano") && photo.reviewed) {
							console.log(photo.url)
							returnVal =  photo.url
						}
					})
					return returnVal
				}
			},
		},

		methods: {
			...mapMutations(['updateContentSidebar', 'setShowPhotoViewer', 'setShowPhotoUpload', 'setSnackText', 'updateRoomAmenitySidebarOpen']),

			addPhoto: function () {
				this.setShowPhotoUpload(true)
			},

			isOwner: function (photo) {
				let netId = jscookie.get(NETID_COOKIE)
				if (this.isSuperUser || photo.netId == netId) { return true}
			},

			showAmenities: function () {
				this.updateRoomAmenitySidebarOpen(true)
			},
		},
	}
</script>

<style>
.buttonhigher2 {
	position: relative;
	bottom: 43px;
	left: -10px;
	width: 70px !important;
	opacity: 0.6;
}

.buttonhigher2 .v-btn__content {
	background-color: white;
    padding: 5px 8px 5px 8px;
    margin-left: 20px;
    color: black;
    font-size: 14px;
    font-weight: 500;
    font-family: Roboto,sans-serif;
}
</style>





// WEBPACK FOOTER //
// src/components/BottomNavigationContent.vue